import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar } from "@/components/Bits";

export default function RecruitersCard({ league }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get(`/leagues/${league.id}/recruiters`).then(({ data }) => setRows(data.rows)).catch(() => setRows([]));
  }, [league.id]);
  if (!rows?.length) return null;
  return (
    <section className="mpl-card p-5 lg:col-span-2" data-testid="recruiters-card">
      <p className="mpl-eyebrow flex items-center gap-1.5"><Award size={13} /> Classement des parrains</p>
      <ol className="mt-3 space-y-2">
        {rows.slice(0, 5).map((r, i) => (
          <li key={r.user_id} className={`flex items-center gap-3 rounded-xl p-2 ${r.is_me ? "bg-[#B7F52A]/[0.06]" : ""}`} data-testid={`recruiter-row-${r.user_id}`}>
            <span className="w-5 font-mono-num text-sm font-bold text-slate-400">{i + 1}</span>
            <Avatar user={r} size={28} />
            <span className="min-w-0 flex-1">
              <span className="block truncate font-semibold">{r.display_name}</span>
              {r.username && <span className="block truncate text-[11px] text-slate-400">@{r.username}</span>}
              {r.top && <span className="mt-0.5 inline-flex items-center gap-0.5 rounded-full bg-sky-300/15 px-1.5 py-0.5 text-[9px] font-bold uppercase text-sky-200" data-testid={`recruiter-top-${r.user_id}`}><Award size={9} /> Meilleur recruteur</span>}
            </span>
            <span className="shrink-0 text-right text-xs text-slate-300" data-testid={`recruiter-count-${r.user_id}`}>
              <b className="font-mono-num text-white">{r.count}</b> invité{r.count > 1 ? "s" : ""}
              {r.points > 0 && <span className="block font-mono-num text-[#B7F52A]">+{r.points} pts</span>}
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
